module.exports = __webpack_public_path__ + "4d95a515bf1f9f36c0175e330e170f1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/tradition_inactive.svg
// module id = 145
// module chunks = 0